import { gql } from '@apollo/client';

export const FIND_ALL_BCP_CORPORATES = gql`
  query FindAllBcpCorporates {
    findAllBcpCorporates {
      uuid
      planUUID
      bcpStatus
      lastBcpUpdate
      corporateLogo
    }
  }
`;

export const FIND_ALL_BCP_CORPORATES_METADATA = gql`
  query FindAllBcpCorporates {
    findAllBcpCorporates {
      planUUID
      lastBcpUpdate
    }
  }
`;

export const FIND_ALL_LOCATIONS = gql`
  query FindAllLocations {
    findAllLocations {
      uuid
      locationName
      planUUID
      primaryStrategyStatus
      primaryStrategyAge
      totalLocationStrategies
      lastBcpUpdate
      bcpStatus
      processAreaStrategies
      processesStrategies
    }
  }
`;

export const FINALIZE_PLAN = gql`
  mutation FinalizePlan($data: FinalizeInput!) {
    finalizePlan(data: $data) {
      lastUpdate
      uuid
    }
  }
`;
